export async function loadFont() {
	const descriptors: FontFaceDescriptors = {
		display: 'swap',
	}
	const sourceHanSansVF = new FontFace(
		'Source Han Sans VF',
		'url(https://cdnv2.ruguoapp.com/lhF8OcS6kz7d1o01IrA2Byxge8qM.woff2)',
		{
			...descriptors,
			weight: '100 900',
		}
	)

	const emojiFont = new FontFace(
		'Noto Color Emoji',
		'url(https://cdnv2.ruguoapp.com/lhfIFbZHptqRzOwPDi9P0WYjLTz2.ttf)',
		{
			...descriptors,
		}
	)

	await Promise.all([sourceHanSansVF.load(), emojiFont.load()])

	return [sourceHanSansVF, emojiFont]
}
